<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom" class="bottom-tabbar">
        <ion-tab-button
            v-for="(i, idx) in tabList"
            :key="idx"
            :class="{ 'active-class': currentIndex === idx }"
            tab="tab1"
            @click="changeBtn(idx)"
        >
          <div v-if="currentIndex === idx" class="checked-icon">
            <img class="pic" :src="i.clickedIcon" alt="" />
          </div>
          <img v-else class="pic" :src="i.icon" alt="" />
          <ion-label class="label">{{ i.label }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { IonLabel, IonPage, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from "@ionic/vue";
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import clickedHomeTab from "@/assets/teacher_index/version5/clicked_home_tab.svg";
import homeTab from "@/assets/teacher_index/version5/home_tab.svg";
import clickedRecordTab from "@/assets/teacher_index/version5/clicked_record_tab.svg";
import recordTab from "@/assets/teacher_index/version5/record_tab.svg";
import clickedStudentTab from "@/assets/teacher_index/version5/clicked_student_tab.svg";
import studentTab from "@/assets/teacher_index/version5/student_tab.svg";
import clickedUserTab from "@/assets/teacher_index/version5/clicked_user_tab.svg";
import userTab from "@/assets/teacher_index/version5/user_tab.svg";
import { checkUserType } from "@/js/message";

const currentIndex = ref(0);
const router = useRouter();
const route = useRoute();
const pathList = ["/TeacherIndex", "/ClassRecord", "/StudentList", "/TeacherPersonalIndex"];
const tabList = [
  { label: "首页", icon: homeTab, clickedIcon: clickedHomeTab },
  { label: "训练记录", icon: recordTab, clickedIcon: clickedRecordTab },
  { label: "学员信息", icon: studentTab, clickedIcon: clickedStudentTab },
  { label: "个人中心", icon: userTab, clickedIcon: clickedUserTab },
];

function changeBtn(type: number) {
  if (checkUserType()) return
  currentIndex.value = type
  router.replace(pathList[type]);
}

watch(
    () => route.path,
    (newVal) => {
      currentIndex.value = pathList.indexOf(newVal);
    },
    { deep: true, immediate: true }
);
</script>
<style scoped>
:deep(.bottom-tabbar) {
  height: 5.5rem;
  display: flex;
  justify-content: space-around;
}

.pic {
  width: 1.62rem;
  position: relative;
  z-index: 2;
}

.checked-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.checked-icon::after {
  content: "";
  display: block;
  width: 2.36rem;
  height: 2.36rem;
  border-radius: 50%;
  background: #c38365;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.label {
  color: #ffffff;
  font-weight: 500;
  margin-top: 0.3rem;
}

.active-class {
  background-image: url("@/assets/version7/bottom_checked_bg.svg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.active-class .label {
  font-weight: 600;
}

.active-class .checked-icon {
  margin-bottom: 0.3rem;
}

.active-class::part(native) {
  padding: 0 0 0.3rem;
}

ion-tab-button {
  margin-top: 0.4rem;
}

ion-tab-button::part(native) {
  /* padding: 0 0 0.3rem; */
}

ion-router-outlet {
  height: calc(100vh - 4.6rem);
}

ion-tab-bar {
  --border: none;
  --background: rgba(255, 255, 255, 0);
  overflow: visible;
  position: relative;
}

ion-tab-bar::after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  display: block;
  height: 4.7rem;
  width: 100%;
  background: #0b6659;
}

@media screen and (min-width: 600px) {
  .label {
    font-size: 3vmin;
  }
}
</style>
